'use es6';

import { createSelector } from 'reselect';
import { ColumnValues, EntityTypes, ALL_NETWORKS } from 'AdsUI/lib/Constants';
import { List } from 'immutable';

const getColumnsData = state => state.columns;

const getNetworkAndEntityFromProps = (__state, props) => ({
  entityType: props.entityType,
  network: props.network
});

export const getSelectedColumns = createSelector(getColumnsData, getNetworkAndEntityFromProps, (columnsData, {
  entityType,
  network
}) => entityType === EntityTypes.NEGATIVE_KEYWORD ? List() : columnsData.getColumns(network, entityType).selected);
export const getSelectedAndPossibleColumns = createSelector(getColumnsData, getNetworkAndEntityFromProps, (columnsData, {
  entityType,
  network
}) => columnsData.getColumns(network, entityType));
export const getCampaignListColumns = createSelector(getColumnsData, columns => columns.getColumns(ALL_NETWORKS, EntityTypes.CAMPAIGN).selected);
export const getAdSequenceAttractStageListColumns = createSelector(getColumnsData, columns => columns.getColumns(ALL_NETWORKS, EntityTypes.AD_SEQ_CAMPAIGNS_ATTRACT_STAGE).selected);
export const getAdSequenceCloseStageListColumns = createSelector(getColumnsData, columns => columns.getColumns(ALL_NETWORKS, EntityTypes.AD_SEQ_CAMPAIGNS_CLOSE_STAGE).selected);
export const getAdSequenceConvertStageListColumns = createSelector(getColumnsData, columns => columns.getColumns(ALL_NETWORKS, EntityTypes.AD_SEQ_CAMPAIGNS_CONVERT_STAGE).selected);
export const getColumnsRequestStatus = state => state.requestStatus.tableColumnOrder;
export const hasSelectedConversionsColumn = createSelector(getColumnsData, colData => colData.selected.valueSeq().flatten().includes(ColumnValues.KEY_RESULTS));
export const getColumnDisplayLabels = createSelector(getColumnsData, columnsData => columnsData.displayStrings.toJS()); // Use the columns because the BE has some logic to try and preserve
// pluralization if the customer is using the default stages

export const getCustomerColumnLabel = createSelector(getColumnDisplayLabels, labels => labels ? labels['CUSTOMERS'] : '');
export const hasConvertedColumns = createSelector(getColumnsData, colData => colData.getColumns(ALL_NETWORKS, EntityTypes.CAMPAIGN).allowed.some(col => col.indexOf('CONVERTED_') === 0));